import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=e397e0de&scoped=true&"
import script from "./appointment.vue?vue&type=script&lang=ts&"
export * from "./appointment.vue?vue&type=script&lang=ts&"
import style0 from "./appointment.vue?vue&type=style&index=0&id=e397e0de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e397e0de",
  null
  
)

export default component.exports